import { selector, selectorFamily } from "recoil";

import { EntityDto } from "../../../dto";
import { Log } from "../../../helpers";
import { RydeUiUnit } from "../../../models";
import { entitiesAtom } from "../../atoms";

export const entityDtoSF = selectorFamily<EntityDto | undefined, RydeUiUnit>({
  key: "entitiesSF",
  get:
    unit =>
    ({ get }) => {
      const entitiesDtos = get(entitiesAtom);
      Log.debug("List of entities fetched", entitiesDtos);

      return entitiesDtos?.find(x => x.name === unit);
    },
});

export const entityIdSF = selectorFamily<number | undefined, RydeUiUnit>({
  key: "entityIdSF",
  get:
    unit =>
    ({ get }) => {
      const entityFull = get(entityDtoSF(unit));
      return entityFull?.id;
    },
});

export const entitiesMappingIdsSelector = selector<Map<number, RydeUiUnit>>({
  key: "entitiesMappingIdsSelector",
  get: ({ get }) => {
    const entities = get(entitiesAtom);
    return new Map(
      entities?.map(({ id, name }) => [id, name as RydeUiUnit]) ?? [],
    );
  },
});
